module.exports = __webpack_public_path__ + "cancellara-dist/img/servizi_business_header.66110c24.png";